import React from 'react';

import css from "./CounterManager.module.css"

import {HoldButton, Odometer} from "../../index";


const CounterManager = (
    {
        isVisible = true,
        count = 0, // Variant A: simple number
        onIncrement,
        onDecrement,
        onAction,
        style = {},
        isActive
    }
) => {

    if (!isVisible) return;

    const styleBtn = {borderRadius: "50%", padding: "0 0.5rem", border: "1px solid var(--border-color)"}
    return (
        <div className={css.container} style={style} onClick={(e)=>e.stopPropagation()}>

            <div className={`${css.animated_div} ${isActive ? css.open : css.closed}`}>
                <div className={css.button_group}>
                    <HoldButton onAction={onDecrement} style={styleBtn} disabled={count === 0}>
                        <div style={{fontSize: "2.5rem", padding: "0 0.5rem 0.3rem"}}>
                            -
                        </div>
                    </HoldButton>
                    <div  className={css.distance} ></div>
                    {/* Checkbox removed from here */}
                    <HoldButton onAction={onIncrement} style={styleBtn} disabled={count === 9}>
                        <div style={{fontSize: "2.5rem", padding: "0 0.2rem"}}>
                            +
                        </div>
                    </HoldButton>
                </div>
            </div>
            <HoldButton className={css.counter} onAction={() => onAction()} style={styleBtn}>
                <Odometer number={count} className={css.odometer}/>
            </HoldButton>
        </div>
    );
};

export {CounterManager};